import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Card, Avatar, TruncateText } from '../ui';
import i18n from '../../shared/util/i18n';
import AvatarPadrao from '../../images/svgs/avatar-padrao.svg';
import { getSmallestImage } from '../../shared/util/imageUtils';
import RatingRow from './components/RatingRow/RatingRow';
import styles from './ProfessionalCard.module.css';

export default function ProfessionalCard({ item }) {
  const foto = item.fotoUrl
    ? getSmallestImage(item.fotoUrlResponsive, item.fotoUrl)
    : AvatarPadrao;
  const nome = item.nome || item.nomeFantasia;

  return (
    <Card
      as={Link}
      to={item.profileLink}
      variant='surface'
      interactive
      className={styles.root}>
      <div className={styles.inner}>
        <Avatar size='xl' src={foto} alt={i18n.t('AVATAR_ALT') + nome} />
        <TruncateText lines={2} className={styles.name}>
          {nome}
        </TruncateText>
        <TruncateText lines={2} className={styles.role}>
          {item.ocupacao}
        </TruncateText>
        <RatingRow value={item.mediaAvaliacao} />
      </div>
    </Card>
  );
}

ProfessionalCard.propTypes = {
  item: PropTypes.shape({
    profileLink: PropTypes.string,
    fotoUrl: PropTypes.string,
    fotoUrlResponsive: PropTypes.object,
    nome: PropTypes.string,
    nomeFantasia: PropTypes.string,
    ocupacao: PropTypes.string,
    mediaAvaliacao: PropTypes.number
  }).isRequired
};
